import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash/fp';

import { ReactComponent as Icon } from '../../../../../../svgs/searchIcon.svg';
import { filterDoctors } from '../../filterFunctions';
import styles from './doctorFilter.module.css';

class DoctorFilter extends Component {
  static propTypes = {
    filterDoctors: PropTypes.func.isRequired,
    currentFilter: PropTypes.string,
  };
  state = {
    currentFilter: this.props.currentFilter,
  };
  constructor(props) {
    super(props);
    this.onChange = debounce(300, this.onChange.bind(this));
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currentFilter !== this.props.currentFilter) {
      this.setState({ currentFilter: this.props.currentFilter });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.currentFilter !== this.props.currentFilter ||
      nextState.currentFilter !== this.state.currentFilter
    );
  }
  onChange(e) {
    this.setState({ currentFilter: this.input.value });
    this.props.filterDoctors(this.input.value);
  }
  render() {
    return (
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          <Icon className={styles.icon} />
          <input
            ref={c => {
              this.input = c;
            }}
            className={styles.input}
            type="text"
            placeholder="Search Practitioner"
            onChange={this.onChange}
            value={this.state.currentFilter}
            onInput={(e) => this.setState({ currentFilter: e.target.value })}
          />
        </div>
      </div>
    );
  }
}

export default DoctorFilter;
